import * as React from 'react'
import map from 'lodash/map'
import range from 'lodash/range'
import flatten from 'lodash/flatten'
import zip from 'lodash/zip'

import {Link} from '@frontrow/console/src/components/ui/link'

export type BreadcrumbItemT = {
  url: string
  name: string
}

export type BreadcrumbsProps = {
  path: Array<BreadcrumbItemT>
  currentItemName: string
}

export function Breadcrumbs(p: BreadcrumbsProps): React.ReactElement {
  const {path, currentItemName} = p

  const pathList: Array<React.ReactNode> = map(path, (breadcrumbItem, i: number) => {
    return (
      <Link
        key={`root-${i}`}
        href={breadcrumbItem.url}
        reactRouter
        dataTest={`breadcrumb-link-${i}`}
      >
        {breadcrumbItem.name}
      </Link>
    )
  })

  const separators: Array<React.ReactNode> = map(range(0, pathList.length), i => {
    return (
      <span key={`separator-${i}`} className="px-2 text-muted-foreground">
        &#47;
      </span>
    )
  })

  const grouppedItems = zip(pathList, separators) as Array<Array<React.ReactNode>>
  const pathNode = flatten(grouppedItems)

  return (
    <div className="text-sm leading-[18px] mb-14 print:hidden" data-test="breadcrumbs">
      {pathNode}
      <span className="text-sm text-center" dangerouslySetInnerHTML={{__html: currentItemName}} />
    </div>
  )
}
